import * as React from "react";
import { forwardRef } from "react";
const SvgNotificationIconInfo = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 28 28", style: {
  enableBackground: "new 0 0 28 28"
}, xmlSpace: "preserve", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", { id: "notification-icon-1", style: {
  fill: "#00c4ff"
}, d: "M15.4,8.8v6.1c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2l0,0V8.8             c0-0.7,0.6-1.2,1.2-1.2C14.8,7.6,15.4,8.1,15.4,8.8L15.4,8.8z M14.1,17.4c0.8,0,1.5,0.7,1.5,1.5c0,0.8-0.7,1.5-1.5,1.5             c-0.8,0-1.5-0.7-1.5-1.5c0-0.4,0.2-0.8,0.4-1C13.4,17.6,13.7,17.4,14.1,17.4z" }), /* @__PURE__ */ React.createElement("circle", { style: {
  fill: "none",
  stroke: "#00c4ff",
  strokeWidth: 2,
  strokeMiterlimit: 10
}, cx: 14.1, cy: 14, r: 12 })));
const ForwardRef = forwardRef(SvgNotificationIconInfo);
export { ForwardRef as ReactComponent };
